exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ref-docs-upload-card{width:208px;height:44px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);display:flex;align-items:center;overflow:hidden;margin-top:4px}.ref-docs-upload-card .image-placeholder{height:32px;max-width:26px;margin-left:7px}.ref-docs-upload-card .ref-doc-upload-details{display:flex;align-items:center}.ref-docs-upload-card .ref-doc-upload-details .ref-doc-file-name{width:141px;font-family:Open Sans,sans-serif;font-size:8px;font-weight:700;color:#2c2c2c;margin-left:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ref-docs-upload-card .ref-doc-upload-details .ref-doc-upload-success{margin-right:8px;margin-left:2px;background-image:url(" + require("../../../../assets/images/cloud-upload-success.svg") + ");background-repeat:no-repeat;width:16px;height:12px}.ref-docs-upload-card .ref-doc-upload-details .ref-doc-upload-failure{margin-right:8px;margin-left:2px;background-image:url(" + require("../../../../assets/images/cloud-upload-fail.svg") + ");background-repeat:no-repeat;width:16px;height:12px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentsUploader/ReferenceDocumentUploadCard/ReferenceDocumentUploadCard.scss
// module id = 1838
// module chunks = 0